export default __webpack_public_path__ + "static/media/Happyfeetpinguin.4cae8832.png";